import { render, staticRenderFns } from "./Anuncio.vue?vue&type=template&id=44ccd516&"
import script from "./Anuncio.vue?vue&type=script&lang=js&"
export * from "./Anuncio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports